module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('h5', [_vm._v("\n        Get instant reservations from your own website.\n    ")]), _vm._v(" "), (_vm.showStripeWarning) ? _c('div', {
    staticClass: "my-4 border-color-6 p-2 radius-normal bg-red-pale"
  }, [_vm._v("\n        " + _vm._s(_vm.stripeWarningMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.showNewWidgetCreator) ? _c('div', {
    staticClass: "d-flex align-items-end mb-4"
  }, [_c('button', {
    staticClass: "btn wide",
    on: {
      "click": _vm.toggleWidgetCreator
    }
  }, [_vm._v("New Widget")])]) : _vm._e(), _vm._v(" "), (_vm.showNewWidgetCreator) ? _c('div', {
    staticClass: "mb-5"
  }, [_c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Create New")]), _vm._v(" "), _c('div', [_c('widget-editor', {
    attrs: {
      "isCreatingWidget": true,
      "widget": _vm.newWidget,
      "productOptions": _vm.productsArray,
      "validation": _vm.$v.newWidget
    },
    on: {
      "update:widget": function($event) {
        _vm.newWidget = $event
      },
      "refreshWidgetList": _vm.downloadAllWidgets,
      "creatingCancel": _vm.creatingCancel,
      "creatingSave": _vm.createWidgetButtonOptions
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.loadingWidgets) ? _c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingWidgets) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.widgetsArray.length > 0) ? _c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Current Widgets")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedWidgets), function(widget) {
    return _c('widget-editor', {
      key: widget.id,
      attrs: {
        "widget": widget,
        "productOptions": _vm.productsArray
      },
      on: {
        "update:widget": function($event) {
          widget = $event
        },
        "refreshWidgetList": _vm.downloadAllWidgets
      }
    })
  })], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-4"
  }, [_vm._v("\n        Reservations received trough this widget are automatically synced with Pluralo calendar."), _c('br'), _vm._v("\n        Availabilities, prices, cancellation policy and other important information you enter in your company configurations will be shown to customers during reservation process.\n    ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-277bac43", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277bac43"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabWidget.vue
// module id = 2580
// module chunks = 0